export var ConversationType;
(function (ConversationType) {
    ConversationType["Wfp"] = "wfp";
    ConversationType["Active"] = "active";
    ConversationType["RemoteClosed"] = "remote_closed";
    ConversationType["LocalClosed"] = "local_closed";
    ConversationType["Deleted"] = "deleted";
    ConversationType["Archived"] = "archived";
})(ConversationType || (ConversationType = {}));
